import React from "react";

const ExtractionPage = () => {
  return <div> Extraction Page</div>;
};

export default ExtractionPage;
